export default "__VITE_ASSET__PZEwhkvZ__"